<template>
  <div class="card-310 col-lg-12 p-0 m-0 ">
    <div class="row h-100 m-0 align-items-center card-310-parent">
      <div class="col-6 card-310-image-parent">
        <m-img class="col-lg-12 p-0 m-0 card-310-image" :src="image" :alt="alt"/>
      </div>
      <div class="col-6 card-310-text-parent">
        <div class="">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mA from '../Tags/A'
import {CardProps} from "./CardProps";
import mImg from "../Tags/Img";

export default {
  name: "Card310",
  components: {mA, mImg},
  props: {
    ...CardProps,
  }
}
</script>

<style scoped>
.card-310, .card-310-image {
  height: 180px;
}

.card-310-image {
  object-fit: contain;
}

</style>